import React from 'react'
import PropTypes from 'prop-types'
import EmptyState from '../ui/EmptyState'
import Loader from '../shared/Loader'
import Pagination, { PER_PAGE_OPTIONS } from '../ui/pagination'
import SectionCard from './SectionCard'
import { VIEW_MODES } from './constants'

const EMPTY_MESSAGE = 'Les récapitulatifs de vos sections apparaîtront ici '
  + 'une fois les données disponibles.'

const SectionsList = ({
  rows, pagy, perPage, viewMode, gradeMax,
  onOpenSection, onPageChange, onPerPageChange, loading
}) => {
  if (loading)
    return <Loader />
  if (rows.length === 0)
    return <EmptyState message={EMPTY_MESSAGE} />

  return (
    <>
      <div className="tw:grid tw:grid-cols-1 tw:lg:grid-cols-2 tw:gap-4 tw:mb-3">
        {rows.map(summary => (
          <SectionCard
            key={summary.id}
            gradeMax={gradeMax}
            summary={summary}
            viewMode={viewMode}
            onOpen={onOpenSection}
          />
        ))}
      </div>
      <Pagination
        lastPage={Math.max(1, pagy.pages)}
        page={pagy.page}
        perPage={perPage}
        perPageLabel="Sections par page :"
        perPageOptions={PER_PAGE_OPTIONS}
        total={pagy.count}
        onPageChange={onPageChange}
        onPerPageChange={onPerPageChange}
      />
    </>
  )
}

SectionsList.propTypes = {
  gradeMax: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  onOpenSection: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onPerPageChange: PropTypes.func.isRequired,
  pagy: PropTypes.shape({
    count: PropTypes.number,
    page: PropTypes.number,
    pages: PropTypes.number
  }).isRequired,
  perPage: PropTypes.number.isRequired,
  rows: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired
  })).isRequired,
  viewMode: PropTypes.oneOf(Object.values(VIEW_MODES)).isRequired
}

SectionsList.defaultProps = {
  loading: false
}

export default SectionsList
